import { Button, ListItem } from '@material-ui/core'
import PropTypes from 'prop-types'
import { matchPath, NavLink as RouterLink, useLocation } from 'react-router-dom'

const NavItem = ({ href, icon: Icon, title, ...rest }) => {
  const location = useLocation()

  const active = href
    ? !!matchPath(
      {
        path: href,
        end: false,
      },
      location.pathname
    )
    : false

  // Extracted styles into a variable
  const navItemStyles = {
    color: active ? 'primary.contrastText' : 'text.secondary',
    fontWeight: 'medium',
    justifyContent: 'flex-start',
    letterSpacing: 0,
    py: 1.25,
    px: 2,
    textTransform: 'none',
    width: '100%',
    borderRadius: 1,
    backgroundColor: active ? 'primary.main' : 'transparent',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: active ? 'primary.dark' : 'rgba(25, 118, 210, 0.1)',
      color: active ? 'primary.contrastText' : 'primary.main',
      transform: 'translateX(4px)',
    },
    '& svg': {
      mr: 1,
      transition: 'color 0.3s ease',
    },
  }

  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        py: 0,
      }}
      {...rest}
    >
      <Button component={RouterLink} sx={navItemStyles} to={href}>
        {Icon && <Icon size="20" />}
        <span>{title}</span>
      </Button>
    </ListItem>
  )
}

NavItem.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
}

export default NavItem;
